import { Grid, Typography } from "@mui/material";
import MainTitle from "../muiHome/mainTitle";

const SAHSAlumni=()=>{
return (
<Grid container spacing={2}>
<Grid item xs={12}>
    <MainTitle title="School of Pharmaceutical Sciences" />
    </Grid>

    <Grid item xs={12}>
    <MainTitle title="Our Alumni" />
    <b>Global Presence:</b>
    </Grid>

    <Grid item xs={12}>
    <Typography textAlign='justify' fontSize="14px" letterSpacing="0.5px" fontFamily="sans-serif" >
    MVN University alumni have established a strong presence in leading multinational corporations, research organizations, educational institutions and entrepreneurial ventures across India and abroad.
    </Typography>
    </Grid>
    <Grid item xs={12}>
    <Typography textAlign='justify' fontSize="14px" letterSpacing="0.5px" fontFamily="sans-serif" >
        <b>Successful Career Placements:</b>
        <br/>
        Our alumni are excelling in reputed organizations such as TCS, Wipro, Infosys, Cognizant, Sun Pharma, Lupin, MVN Infra, Adsila Organics Pvt, Ltd., Combitic Global Caplet Pvt. Ltd., Arvin Care, Sunvet Healthcare, Nestor Pharmaceuticals Limited and various government sectors, showcasing the strength of MVN's academic foundation.
    </Typography>
    </Grid>
    <Grid item xs={12}>
    <Typography textAlign='justify' fontSize="14px" letterSpacing="0.5px" fontFamily="sans-serif" >
        <b>Entrepreneurship and Startups:</b>
        <br/>
        Many alumni have successfully launched their own startups, becoming job creators and innovators across industries like technology, healthcare, education and consulting.
    </Typography>
    </Grid>
    <Grid item xs={12}>
    <Typography textAlign='justify' fontSize="14px" letterSpacing="0.5px" fontFamily="sans-serif" >
        <b>Higher Education Pursuits:</b>
        <br/>
        A significant number of alumni have pursued higher education at premier institutions in India and overseas, including IITs, IIMs, and top universities in the USA, UK, Australia and Canada.
    </Typography>
    </Grid>
    <Grid item xs={12}>
    <Typography textAlign='justify' fontSize="14px" letterSpacing="0.5px" fontFamily="sans-serif" >
        <b>Government and Public Sector Roles:</b>
        <br/>
        MVN graduates have secured prestigious positions in government bodies like Drug Inspector, Drug Analyst, Food inspector, public sector undertakings and administrative services through competitive examinations.
    </Typography>
    </Grid>
    <Grid item xs={12}>
    <Typography textAlign='justify' fontSize="14px" letterSpacing="0.5px" fontFamily="sans-serif" >
        <b>Research and Academic Contributions:</b>
        <br/>
        Alumni have made notable contributions to research and academia, publishing in national and international journals and serving as faculty members at leading educational institutions.
    </Typography>
    </Grid>
    <Grid item xs={12}>
    <Typography textAlign='justify' fontSize="14px" letterSpacing="0.5px" fontFamily="sans-serif" >
        <b>Active Alumni Network:</b>
        <br/>
        MVN University boasts a vibrant and engaged alumni network that regularly participates in mentorship programs, career guidance sessions, guest lectures and university events.
    </Typography>
    </Grid>
    <Grid item xs={12}>
    <Typography textAlign='justify' fontSize="14px" letterSpacing="0.5px" fontFamily="sans-serif" >
        <b>Recognition and Awards:</b>
        <br/>
        Many alumni have been recognized with industry awards, innovation accoladesand honours for their contributions in their respective fields.
    </Typography>
    <br></br>
    </Grid>
    </Grid>

)
}
export default SAHSAlumni;